import { render, staticRenderFns } from "./BlueberryIcon.vue?vue&type=template&id=223af1bf&"
import script from "./BlueberryIcon.vue?vue&type=script&lang=js&"
export * from "./BlueberryIcon.vue?vue&type=script&lang=js&"
import style0 from "./BlueberryIcon.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports